export const SET_ROLE_LIST = 'SET_ROLE_LIST';
export const SET_MODULE_LIST = 'SET_MODULE_LIST';
export const SET_LOADING_ON = 'SET_LOADING_ON';
export const SET_LOADING_OFF = 'SET_LOADING_OFF';
